// Code snippet taken from: https://developers.heap.io/docs/web#base-installation
// eslint-disable-next-line func-names
export default function (apiKey, config) {
  window.heap.appid = apiKey;
  // eslint-disable-next-line no-multi-assign, no-param-reassign
  window.heap.config = config ||= {};

  const properties = [
    'addEventProperties',
    'addUserProperties',
    'clearEventProperties',
    'identify',
    'resetIdentity',
    'removeEventProperty',
    'setEventProperties',
    'track',
    'unsetEventProperty',
  ];

  for (const heapProperty of properties) {
    // eslint-disable-next-line func-names
    window.heap[heapProperty] = function () {
      // eslint-disable-next-line unicorn/prefer-spread, prefer-rest-params
      window.heap.push([heapProperty].concat(Array.prototype.slice.call(arguments, 0)));
    };
  }
}
